module.exports = __webpack_public_path__ + "img/Facebook-Checkin.c05e8081.svg";